<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1">
      <!-- MainView -->
      <article class="wrapper wrapper-content main-column full-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
                <img src="static/img/assets/nav_okr_on.png" alt="">
                {{$t('helpStr')}}
            </h1>
        </div>
        <!-- /ViewTitleBox -->
        <section class="animated fadeInRight flex-option">
          <!-- <web-view-helps /> -->
          <div v-if="!isLiteMode">
            <web-view-helps-ja-re v-if="this.checkLanguage === 'ja'"/>
            <web-view-helps-en-re v-else-if="this.checkLanguage === 'en'" />
            <web-view-helps-zh-re v-else-if="this.checkLanguage === 'zh_tr'" />
          </div>
          <div v-else>
            <lite-web-view-helps-ja-re v-if="this.checkLanguage === 'ja'"/>
            <lite-web-view-helps-en-re v-else-if="this.checkLanguage === 'en'" />
            <lite-web-view-helps-zh-re v-else-if="this.checkLanguage === 'zh_tr'" />
          </div>
      </section>
    </article>
      <!-- DetailView -->
      <!-- <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <article class="sub-content-wrap">
          <section>
          </section>
        </article>
      </div> -->
    </div>
  </div>
</template>

<script>
import { i18n, liteMode } from '@/main.js'
// import WebViewHelps from '@/views/_webview/WebViewHelps'
import WebViewHelpsJaRe from '@/views/_webview/WebViewHelpsJARe'
import WebViewHelpsEnRe from '@/views/_webview/WebViewHelpsENRe'
import WebViewHelpsZhRe from '@/views/_webview/WebViewHelpsZHRe'
import LiteWebViewHelpsJaRe from '@/views/_webview/LiteWebViewHelpsJARe'
import LiteWebViewHelpsEnRe from '@/views/_webview/LiteWebViewHelpsENRe'
import LiteWebViewHelpsZhRe from '@/views/_webview/LiteWebViewHelpsZHRe'
export default {
  name: 'Help',
  components: {
    WebViewHelpsJaRe,
    WebViewHelpsEnRe,
    WebViewHelpsZhRe,
    LiteWebViewHelpsJaRe,
    LiteWebViewHelpsEnRe,
    LiteWebViewHelpsZhRe
  },
  data: function () {
    return {
      isLiteMode: liteMode
    }
  },
  computed: {
    checkLanguage () {
      return i18n.locale
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flex-option{
    display: flex;
    flex-direction: column-reverse;
  }
</style>



// WEBPACK FOOTER //
// src/views/webview/Help.vue